"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LargeText = exports.Paragraph = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const common_buoy_button_1 = require("@buoyhealth/common.buoy-button");
const common_buoy_theme_1 = require("@buoyhealth/common.buoy-theme");
const styled_components_1 = __importDefault(require("styled-components"));
const FeedbackCopy_1 = __importDefault(require("../../common/FeedbackCopy"));
exports.Paragraph = styled_components_1.default.p `
  ${({ theme }) => theme.typography.variants.primary.main};
  margin: 0;

  ${(0, common_buoy_theme_1.mobileFirstResponsive)({
    field: "max-width",
    values: { lg: "423px" },
})};
`;
const ParagraphWithMargin = (0, styled_components_1.default)(exports.Paragraph) `
  margin: 32px 0;

  ${(0, common_buoy_theme_1.mobileFirstResponsive)({
    field: "margin-bottom",
    values: { md: "72px", lg: "32px" },
})};
`;
exports.LargeText = styled_components_1.default.p `
  ${({ theme }) => theme.typography.variants.primary.larger};
  margin: 0 0 16px;

  ${(0, common_buoy_theme_1.mobileFirstResponsive)({
    field: "font-size",
    values: { xs: "24px", lg: "32px" },
})};
`;
const ButtonContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;

  ${(0, common_buoy_theme_1.mobileFirstResponsive)({
    field: "align-items",
    values: { xs: "center", lg: "flex-start" },
})};
`;
const StyledCTAButton = (0, styled_components_1.default)(common_buoy_button_1.CTAButton) `
  ${(0, common_buoy_theme_1.mobileFirstResponsive)({
    field: "width",
    values: { lg: "auto", md: "50%", xs: "100%" },
})};
`;
const StyledCloseButton = (0, styled_components_1.default)(common_buoy_button_1.SecondaryCTAButton) `
  margin-top: 16px;

  ${(0, common_buoy_theme_1.mobileFirstResponsive)({
    field: "display",
    values: { lg: "none" },
})};

  ${(0, common_buoy_theme_1.mobileFirstResponsive)({
    field: "width",
    values: { lg: "auto", md: "50%", xs: "100%" },
})};
`;
const SurveyThankYou = ({ handleClose, handleSurveyClick, surveyLink, }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(exports.LargeText, { children: FeedbackCopy_1.default.ThankYou }), (0, jsx_runtime_1.jsx)(exports.Paragraph, { children: FeedbackCopy_1.default.ThankYouParagraph1 }), (0, jsx_runtime_1.jsx)(ParagraphWithMargin, { children: FeedbackCopy_1.default.ThankYouParagraph2 }), (0, jsx_runtime_1.jsxs)(ButtonContainer, { children: [(0, jsx_runtime_1.jsx)(StyledCTAButton, { "data-testid": "survey-link", href: surveyLink, onClick: handleSurveyClick, target: "_blank", children: FeedbackCopy_1.default.TakeOurSurvey }), (0, jsx_runtime_1.jsx)(StyledCloseButton, { onClick: handleClose, children: FeedbackCopy_1.default.Close })] })] }));
exports.default = SurveyThankYou;
//# sourceMappingURL=index.js.map